/**
 * Stable string key for a cart line item. Use for `SerialRowMap` and any
 * lookups that must stay aligned across hydration (e.g. Mongo ObjectId vs string).
 */
export function cartItemKey(
  item: { _id?: unknown } | null | undefined,
): string {
  if (item == null || item._id == null) return '';
  const id = item._id;
  if (typeof id === 'string') return id;
  return String(id);
}
